<template>
  <BasePaymentModal :name="name" @onProceed="emit('onProceed')">
    <template #title>
      {{ title }}
    </template>
    <template #description>
      {{ description }}
    </template>
    <template #buttonText>
      {{ buttonText }}
    </template>
  </BasePaymentModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import messages from '../config/locales.json';
  import BasePaymentModal from './BasePaymentModal.vue';

  const props = defineProps<{
    name: string;
    isSurcharge?: boolean;
  }>();

  const emit = defineEmits<{ onProceed: [] }>();

  const { t } = useI18n({ messages });
  const title = computed(() =>
    t('paymentErrorsModals.paymentExpired.title.base', {
      paymentType: props.isSurcharge
        ? t('paymentErrorsModals.paymentExpired.title.surcharge')
        : t('paymentErrorsModals.paymentExpired.title.payment'),
    }),
  );
  const description = computed(() =>
    t('paymentErrorsModals.paymentExpired.description.base', {
      orderType: props.isSurcharge
        ? t('paymentErrorsModals.paymentExpired.description.surcharge')
        : t('paymentErrorsModals.paymentExpired.description.order'),
    }),
  );
  const buttonText = computed(() =>
    props.isSurcharge
      ? t('paymentErrorsModals.returnToOrder')
      : t('paymentErrorsModals.startNewSearch'),
  );
</script>
